// extracted by css-extract-rspack-plugin
export default {"formCheckboxRoot":"WFb6sb","formCheckboxWrapper":"bpbjO6"};